export const searchGiftTableFormatter = (values, page = 1) => ({
  gifttable_id: values.eventNumber || '',
  celebrate_name: values.eventName || '',
  gifttable_date: values.eventDate || '',
  type_id: values.eventType || '',
  customer_sears_id: values.customerSearsId || '',
  page,
  open_orders:true
});
